// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from 'react-localized'
import { client } from './GatewayClient'
import { LoadingIonButton } from "./LoadingIonButton"



interface LoginParameters {
  prompt?: "select_account"
}


const LoginButton: React.FC<any & {children?: React.ReactNode | string, params?: LoginParameters}> = ({children, params, ...props}) => {
  const { locale } = useLocales()
  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
  return (
    <LoadingIonButton
      onSubmit={async () => {
        window.location.href = await client.login(locale, window.location.href, params)
        await sleep(2500)
      }}
      {...props}
    >
      {children}
    </LoadingIonButton>
  )
}

export { LoginButton }